import { connect } from 'react-redux';
import Panel from './panel';
import { closePanel } from '../../actions/panel';

const mapStateToProps = ({ panel }) => ({ ...panel });

export default connect(mapStateToProps, { closePanel })(Panel);
